import Enums from "../../../../utils/Enums";

const GAMRBenefits = {
  headers: [
    {
      title: `Benefits / Plan Type`,
      mandatory: true,
      attributes: {
        style: {
          width: "30%"
        }
      }
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>Accidental Medical Reimbursement</strong>`,
          info: `<i>(Optional Benefit to GADD)</i>`
        },
        {
          data: `S$ 5,000`,
          info: `(for Employee only)`,
          attributes: {
            colspan: 2
          }
        },
        {
          data: `S$ 5,000`,
          info: `(for Employee only)`,
          attributes: {
            colspan: 2
          }
        },
        {
          data: `S$ 5,000`,
          info: `(for Employee only)`,
          attributes: {
            colspan: 2
          }
        },
        {
          data: `S$ 5,000`,
          info: `(for Employee only)`,
          attributes: {
            colspan: 2
          }
        },
        {
          data: `S$ 5,000`,
          info: `(for Employee only)`,
          attributes: {
            colspan: 2
          }
        }
      ]
    }
  ],
  footnotes: []
};

let GAMRPremium = {
  title: `Annual Premium Rate (inclusive of 7% GST) – Group Accidental Medical Reimbursement`,
  headers: [
    {
      title: `Occupational Class`,
      mandatory: true
    },
    {
      title: `Age Last Birthday`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>Class 1</strong>`,
          attributes: {
            rowspan: 2
          }
        },
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 37.00`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `<em>For renewals only</em>`
        },
        {
          data: `S$ 155.00`
        },
        {
          data: `S$ 155.00`
        },
        {
          data: `S$ 155.00`
        },
        {
          data: `S$ 155.00`
        },
        {
          data: `S$ 155.00`
        }
      ]
    },
    {
      id: 3,
      columns: [
        {
          data: `<strong>Class 2</strong>`,
          attributes: {
            rowspan: 2
          }
        },
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 46.00`
        },
        {
          data: `S$ 46.00`
        },
        {
          data: `S$ 46.00`
        },
        {
          data: `S$ 46.00`
        },
        {
          data: `S$ 46.00`
        }
      ]
    },
    {
      id: 4,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `<em>For renewals only</em>`
        },
        {
          data: `S$ 193.00`
        },
        {
          data: `S$ 193.00`
        },
        {
          data: `S$ 193.00`
        },
        {
          data: `S$ 193.00`
        },
        {
          data: `S$ 193.00`
        }
      ]
    },
    {
      id: 5,
      columns: [
        {
          data: `<strong>Class 3</strong>`,
          attributes: {
            rowspan: 2
          }
        },
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 64.00`
        },
        {
          data: `S$ 64.00`
        },
        {
          data: `S$ 64.00`
        },
        {
          data: `S$ 64.00`
        },
        {
          data: `S$ 64.00`
        }
      ]
    },
    {
      id: 6,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `<em>For renewals only</em>`
        },
        {
          data: `S$ 270.00`
        },
        {
          data: `S$ 270.00`
        },
        {
          data: `S$ 270.00`
        },
        {
          data: `S$ 270.00`
        },
        {
          data: `S$ 270.00`
        }
      ]
    }
  ],
  footnotes: []
};

//   ----------------------------------------------------------------------
const GAMR = {
  id: 1,
  code: "GAMR",
  label: "Group Accidental Medical Reimbursement (GAMR)",
  types: [
    {
      id: 1,
      order: 1,
      type: Enums.PLANS_TYPE.BENEFITS,
      label: "Plans by Benefits",
      data: [GAMRBenefits]
    },
    {
      id: 2,
      order: 2,
      type: Enums.PLANS_TYPE.PREMIUMS,
      label: "Plans by Premium (inclusive of 7% GST)",
      data: [GAMRPremium]
    }
  ]
};

export default GAMR;
